import React from 'react';
import { cloneDeep } from 'lodash-es';

import {
  titleUI,
  fullNameSchema,
  fullNameUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

const updatedFullNameSchema = cloneDeep(fullNameSchema);
updatedFullNameSchema.properties.first.maxLength = 40;
updatedFullNameSchema.properties.last.maxLength = 50;

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['claimant-name-title']),
    'ui:description': <p>{content['claimant-name-description']}</p>,
    claimantFullName: fullNameUI(),
  },
  schema: {
    type: 'object',
    required: ['claimantFullName'],
    properties: {
      claimantFullName: updatedFullNameSchema,
    },
  },
};
